var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notice-history" },
    _vm._l(_vm.notices, function (notice) {
      return _c(
        "div",
        { key: notice.id, staticClass: "notice", class: notice.type },
        [
          _c(
            "div",
            { staticClass: "badge" },
            [
              _c("v-icon", [_vm._v("mdi-alert")]),
              _vm._v(" "),
              _c("span", { staticClass: "mx-auto" }, [
                _vm._v(_vm._s(_vm.$t("label." + notice.type))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "message" }, [
            _c("div", { staticClass: "mr-2" }, [_vm._v(_vm._s(notice.date))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-center" },
              [
                _c("span", [_vm._v(_vm._s(notice.message))]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "ml-2 link-icon",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.navigateToActivity(notice)
                      },
                    },
                  },
                  [_vm._v("\n          mdi-open-in-new\n        ")]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }